import { useState } from 'react';
import { Abas, PainelDeAba } from '../componentes/Abas.js';
import { Pagina } from '../componentes/Pagina.js';
import { AbaOperadores } from './usuarios/AbaOperadores.js';
import { AbaUsuariosDoPainel } from './usuarios/AbaUsuariosDoPainel.js';
import { MatrizDePermissoes } from './usuarios/MatrizDePermissoes.js';
import './Usuarios.css';

const GRUPO = 'usuarios';

const ABAS = [
  { id: 'painel', rotulo: 'Usuários do painel' },
  { id: 'operadores', rotulo: 'Operadores do app' },
];

/**
 * Usuários e permissões (UC13, RF-078).
 *
 * A área é dividida em duas porque são duas populações diferentes: quem abre o
 * navegador e quem entra no coletor. Misturá-las numa tabela só seria dizer
 * que perfil do painel e matrícula de armazém são a mesma coisa.
 *
 * A matriz de permissões fica abaixo das duas, sempre visível: o administrador
 * precisa ver o que está concedendo no momento em que concede.
 */
export function Usuarios() {
  const [aba, definirAba] = useState('painel');

  return (
    <Pagina
      contexto="Usuários"
      titulo="Usuários e permissões"
      faixa={
        <div className="usuarios__faixa">
          <Abas rotulo="Usuários" grupo={GRUPO} abas={ABAS} ativa={aba} aoTrocar={definirAba} />
        </div>
      }
    >
      {aba === 'painel' ? (
        <PainelDeAba id="painel" grupo={GRUPO}>
          <AbaUsuariosDoPainel />
        </PainelDeAba>
      ) : (
        <PainelDeAba id="operadores" grupo={GRUPO}>
          <AbaOperadores />
        </PainelDeAba>
      )}

      <MatrizDePermissoes />
    </Pagina>
  );
}
